import React, { useState } from 'react';
import { useFloatMessage, MESSAGE_TYPE } from './../../../Providers/FloatMessage';
import { DisqualifyParticipant } from './../../../../utilities/BL/QuizzB9Zone';

export function QuizzB9ZoneDisqualifyModal({ isOpen, participant, onClose, onDisqualified }) {
    const { showMessage } = useFloatMessage();
    const [reason, setReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen || !participant) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!reason.trim()) {
            showMessage({
                type: MESSAGE_TYPE.BAD,
                text: 'Por favor indica el motivo de la descalificación.'
            });
            return;
        }

        setIsSubmitting(true);
        try {
            const res = await DisqualifyParticipant(participant.id, reason.trim());
            if (res.success) {
                showMessage({
                    type: MESSAGE_TYPE.SUCCESS,
                    text: `El participante ${participant.name} ha sido descalificado.`
                });
                if (onDisqualified) onDisqualified(participant.id, reason.trim());
                onClose();
            } else {
                showMessage({
                    type: MESSAGE_TYPE.BAD,
                    text: res.message || 'Error al descalificar participante.'
                });
            }
        } catch (error) {
            showMessage({
                type: MESSAGE_TYPE.BAD,
                text: 'Error de conexión al procesar la descalificación.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div 
            className="modal fade show d-block" 
            tabIndex="-1" 
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.65)', backdropFilter: 'blur(4px)', zIndex: 1070 }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content shadow-lg border-0 rounded-4">
                    <div className="modal-header bg-danger text-white border-0 px-4 py-3">
                        <h5 className="modal-title fw-bold d-flex align-items-center gap-2">
                            <i className="bi bi-shield-x"></i>
                            Descalificar Participante
                        </h5>
                        <button 
                            type="button" 
                            className="btn-close btn-close-white" 
                            aria-label="Close"
                            onClick={onClose}
                        ></button>
                    </div>

                    <div className="modal-body p-4 bg-light">
                        <div className="card border-0 shadow-sm p-3 bg-white rounded-3 mb-3">
                            <div className="fw-bold text-dark fs-6 mb-1">{participant.name}</div>
                            <div className="small text-secondary mb-1">
                                <i className="bi bi-envelope me-1"></i>{participant.email}
                            </div>
                            <div className="small text-secondary mb-1">
                                <i className="bi bi-whatsapp text-success me-1"></i>{participant.phone}
                            </div>
                            {participant.passCode && (
                                <div className="mt-2">
                                    <span className="badge bg-warning text-dark fw-bold">
                                        Folio: {participant.passCode} (Rank #{participant.winnerRank})
                                    </span>
                                </div>
                            )}
                        </div>

                        <form onSubmit={handleSubmit} id="disqualifyForm">
                            <label className="form-label fw-semibold text-secondary small">
                                Motivo de descalificación *
                            </label>
                            <textarea 
                                className="form-control mb-2"
                                rows="3"
                                placeholder="Ej. No se presentó en el horario indicado / Conducta inapropiada / Información fraudulenta..."
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                required
                            ></textarea>
                            <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>
                                Este motivo quedará registrado en el historial y reporte de la jornada. Si fue un error, podrás quitar la descalificación más adelante.
                            </small>
                        </form>
                    </div>

                    <div className="modal-footer bg-white border-top px-4 py-3 d-flex justify-content-between">
                        <button 
                            type="button" 
                            className="btn btn-outline-secondary px-4 fw-semibold"
                            onClick={onClose}
                            disabled={isSubmitting}
                        >
                            Cancelar
                        </button>
                        <button 
                            type="submit" 
                            form="disqualifyForm"
                            className="btn btn-danger px-4 fw-bold d-flex align-items-center gap-2"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status"></span>
                                    Descalificando...
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-x-circle-fill"></i>
                                    Confirmar Descalificación
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuizzB9ZoneDisqualifyModal;
